module.exports = __webpack_public_path__ + "SOUMYADEEP-d7ba8bb5.png";